<mat-card class="system-card">
	<mat-card-header>
		<div class="card-header-row">
			<mat-card-title>
				@if (state.settlementBonusesLoading()) {
					<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
				}
				Dodatki / potrącenia ({{ state.settlementBonuses().length }})
			</mat-card-title>
			<div class="load-action">
				<button mat-stroked-button color="primary" type="button" (click)="openAddDialog()">
					<mat-icon><i class="fa-solid fa-plus"></i></mat-icon>
					Dodaj dodatek/potrącenie
				</button>
				@if (state.navbridgeBonusesLoadedAt()) {
					<span class="loaded-at"
						>Ostatnio: {{ state.navbridgeBonusesLoadedAt() | date: 'd MMM yyyy, HH:mm' }}</span
					>
				}
				<span
					[matTooltip]="state.navbridgeBonusesTooltip()"
					[matTooltipDisabled]="!state.navbridgeBonusesTooltip()"
					matTooltipPosition="above"
				>
					<button
						mat-raised-button
						color="primary"
						(click)="state.loadNavbridgeBonuses()"
						[disabled]="state.navbridgeBonusesDisabled()"
					>
						@if (state.navbridgeBonusesLoading()) {
							<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
						}
						Ściągnij dodatki
					</button>
				</span>
			</div>
		</div>
	</mat-card-header>
	<mat-card-content>
		@if (state.navbridgeBonusesError()) {
			<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
				<i class="bi bi-exclamation-triangle-fill me-2"></i>
				<div><strong>Błąd:</strong> {{ state.navbridgeBonusesError() }}</div>
			</div>
		}
		@if (state.navbridgeBonusesStats(); as stats) {
			@if (stats.skipped_no_driver > 0 || stats.errors > 0) {
				<div class="alert alert-warning d-flex align-items-start mb-3" role="alert">
					<i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
					<div>
						<strong>Ostrzeżenie:</strong>
						@if (stats.skipped_no_driver > 0) {
							pominięto {{ stats.skipped_no_driver }} pozycji bez kierowcy.
						}
						@if (stats.errors > 0) {
							{{ stats.errors }} pozycji zakończyło się błędem.
						}
					</div>
				</div>
			}
		}
		@if (state.bonusExclusionError()) {
			<div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
				<i class="fa-solid fa-triangle-exclamation me-2"></i>
				<div><strong>Błąd:</strong> {{ state.bonusExclusionError() }}</div>
			</div>
		}
		<mat-accordion multi>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						Dodatki w miesiącu ({{ state.settlementPositive().length }})
						@if (state.settlementPositive().length > 0) {
							<span class="praca-total"
								>· {{ state.settlementPositiveTotal() | priceCurrency: 'PLN' }}</span
							>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.settlementPositive().length > 0) {
					<div class="tourism-events-list">
						@for (row of state.settlementPositive(); track row.id) {
							<app-salary-settlement-bonus-row
								[bonusId]="row.id"
								[date]="row.date"
								[name]="row.name"
								[amountGrosze]="row.amountGrosze"
								[currency]="row.currency"
								[isSettled]="row.isSettled"
								[confirmAt]="row.confirmAt"
								[bonusComment]="row.comment"
								[excluded]="row.excluded"
								[exclusionComment]="row.exclusionComment"
								[disabled]="state.isSettled()"
							/>
						}
					</div>
				} @else if (!state.settlementBonusesLoading()) {
					<p class="empty-state">Brak dodatków dla tego kierowcy w wybranym miesiącu.</p>
				}
			</mat-expansion-panel>
			<mat-expansion-panel class="tourism-events-panel" expanded>
				<mat-expansion-panel-header>
					<mat-panel-title>
						Potrącenia w miesiącu ({{ state.settlementNegative().length }})
						@if (state.settlementNegative().length > 0) {
							<span class="praca-total"
								>· {{ state.settlementNegativeTotal() | priceCurrency: 'PLN' }}</span
							>
						}
					</mat-panel-title>
				</mat-expansion-panel-header>
				@if (state.settlementNegative().length > 0) {
					<div class="tourism-events-list">
						@for (row of state.settlementNegative(); track row.id) {
							<app-salary-settlement-bonus-row
								[bonusId]="row.id"
								[date]="row.date"
								[name]="row.name"
								[amountGrosze]="row.amountGrosze"
								[currency]="row.currency"
								[isSettled]="row.isSettled"
								[confirmAt]="row.confirmAt"
								[bonusComment]="row.comment"
								[excluded]="row.excluded"
								[exclusionComment]="row.exclusionComment"
								[disabled]="state.isSettled()"
							/>
						}
					</div>
				} @else if (!state.settlementBonusesLoading()) {
					<p class="empty-state">Brak potrąceń dla tego kierowcy w wybranym miesiącu.</p>
				}
			</mat-expansion-panel>
		</mat-accordion>
	</mat-card-content>
</mat-card>
